// extracted by mini-css-extract-plugin
export default {"loginForm":"login_loginForm__Sa5se","title":"login_title__WX3Lj"};